// DialCare telemedicine (DCCF) and mental wellness (DMCF) are virtual-only — they have
// no provider directory to search, so they must not influence which search group a plan
// maps to. Leaving them in the key drops plans such as WFIT009 onto the fallback group,
// which advertises benefits the member does not have.
const NON_SEARCHABLE_CODES: string[] = ['DCCF', 'DMCF'];

export class GroupCodeUtility {
  public static determineGroupCode(ancillaryCodes?: string, explicitGroupCode?: string): string {
    if (explicitGroupCode) {
      return explicitGroupCode;
    }

    if (!ancillaryCodes) {
      return 'WFIT-PSL1';
    }

    const codes = ancillaryCodes.split('|')
      .map(code => code.trim())
      .filter(code => code && !NON_SEARCHABLE_CODES.includes(code));
    const sortedCodes = codes.sort();
    const codesKey = sortedCodes.join(',');

    const codeMapping: { [key: string]: string } = {
      'AMST,ENVC,EYEM': 'WFIT-PSL1',
      'AMST,ENVC,EYEM,HRPO': 'WFIT-PSL2',
      'AMST,EYEM,HRPO,MEDI': 'WFIT-PSL3',
      'AMST,EYEM,MEDI': 'WFIT-PSL4',
      'AMST,EYEM,HRPO': 'WFIT-PSL5',
      'AMST,EYEM,UNOA': 'WFIT-PSL6',
      'EYEM,MEDI': 'WFIT-PSL7',
      'UNOA': 'WFIT-PSL8',
      'MEDI': 'WFIT-PSL9'
    };

    return codeMapping[codesKey] || 'WFIT-PSL2';
  }
}
